import { GetAllJoints, GetAllBones } from "@project-rouge/rg-core";
import { MuscleToVector } from "@project-rouge/rg-three";
import { WingUtils } from "./index178.js";
import { BoneToVector } from "./index50.js";
import { getRequiredCores } from "./index53.js";
import { hasCornerCore } from "./index177.js";
const LINE_CUTOFF_FACTOR = 2.8;
const L_SHAPE_CUTOFF_FACTOR = 2;
const CalcAnatomyCores = (joint, dataset) => {
  const joints = GetAllJoints(joint);
  const bones = GetAllBones(joint);
  const { requiredFireLifts, requiredNonFireLifts, requiredStairs, highestBones } = getRequiredCores(joint, dataset);
  let cornerCores = 0;
  for (const j of joints) {
    if (hasCornerCore(j))
      cornerCores += 1;
  }
  const additionalFireCores = Math.max(0, requiredFireLifts - cornerCores);
  const additionalLiftCores = Math.max(0, requiredNonFireLifts - Math.max(0, cornerCores - requiredFireLifts));
  const additionalStairCores = Math.max(0, requiredStairs - Math.max(0, cornerCores - requiredFireLifts - requiredNonFireLifts));
  if (additionalFireCores === 0 && additionalLiftCores === 0 && additionalStairCores === 0)
    return;
  const highestMuscles = highestBones.flatMap((b) => b.muscles);
  highestMuscles.sort((a, b) => MuscleToVector(b).lengthSq() - MuscleToVector(a).lengthSq());
  if (additionalFireCores > 0 || additionalLiftCores > 0) {
    if (highestBones.some((b) => b.loads[0] && b.loads[1])) {
      for (const m of highestMuscles) {
        if (!m.skipCores) {
          m.fireCores = additionalFireCores;
          m.liftCores = additionalLiftCores;
          break;
        }
      }
    } else {
      const m = highestMuscles[0];
      m.fireCores = additionalFireCores;
      m.liftCores = additionalLiftCores;
    }
  }
  if (additionalStairCores > 0) {
    const totalBoneLength = bones.reduce((s, b) => s + BoneToVector(b).length(), 0);
    const isLineShape = bones.length === 1;
    const isLShape = bones.length === 2;
    const lineShapeCutoff = LINE_CUTOFF_FACTOR * WingUtils.MinWingWidth({ dataset, corners: 0, hasCore: true });
    const lShapeCutoff = L_SHAPE_CUTOFF_FACTOR * WingUtils.MinWingWidth({ dataset, corners: 1, hasCore: false });
    let cutoff = 0;
    if (isLineShape)
      cutoff = lineShapeCutoff;
    if (isLShape)
      cutoff = lShapeCutoff;
    if (totalBoneLength < cutoff) {
      if (highestBones.some((b) => b.loads[0] && b.loads[1])) {
        for (const m of highestMuscles) {
          if (m.skipCores) {
            m.skipCores = false;
            m.stairCores = additionalStairCores;
            break;
          }
        }
      } else {
        const m = highestMuscles[0];
        m.skipCores = false;
        m.stairCores = additionalStairCores;
      }
    }
  }
};
export {
  CalcAnatomyCores
};
//# sourceMappingURL=index51.js.map
